<script>
import {
	deleteBooking,
	updateBookingStatusToConfirm,
	getInvoiceNumber,
} from "../../../api/services/booking.service";
export default {
	props: {
		visible: Boolean,
		closeable: Boolean,
		booking: Object,
	},
	data() {
		return {
			bookingId: null,
			bookingTitle: null,
			type: null,
			status: null,
			reserverName: null,
			reserverEmail: null,
			reserverTelephone: null,
			numOfPacks: null,
			subPackage: null,
			extras: null,
			totalPrice: null,
			startTime: null,
			endTime: null,
			bookingNote: null,
			bookingValid: false,
			bookingPassed: false,
			paymentMethod: null,
			editBookingFailed: false,
			confirmBookingSuccess: false,
			deleteBookingSuccess: false,
			deleteBookingFailed: false,
			paymentId: null,
			bookingInvoiceNo: null,
		};
	},
	computed: {
		showModal: {
			get() {
				return this.visible;
			},
			set(value) {
				if (!value) {
					this.$emit("close");
				}
			},
		},
	},
	mounted() {
		if (this.booking) {
			this.bookingId = this.booking.bookingId;
			this.bookingTitle = this.booking.bookingTitle;
			this.type = this.booking.type;
			this.totalPrice = this.booking.totalPrice;
			this.status = this.booking.status;
			this.reserverName = this.booking.reserverName;
			this.reserverEmail = this.booking.reserverEmail;
			this.reserverTelephone = this.booking.reserverTelephone;
			this.numOfPacks = this.booking.numOfPacks;
			this.startTime = new Date(this.booking.startTime);
			this.endTime = new Date(this.booking.endTime);
			this.subPackage = this.booking.subPackage;
			this.extras = this.booking.extras;
			this.bookingValid = this.booking.bookingValid;
			this.bookingNote = this.booking.bookingNote;
			this.bookingPassed = this.booking.bookingPassed;
			this.paymentMethod = this.booking.paymentMethod;
			this.paymentId = this.booking.paymentId;
		}
		this.getInvoiceNo();
	},
	methods: {
		clickCloseButton() {
			this.$emit("close");
		},
		async clickDeleteBookingButton() {
			let deleteServiceBookingSuccess = await deleteBooking(this.bookingId);
			if (deleteServiceBookingSuccess) {
				this.deleteBookingSuccess = true;
				this.$emit("reload");
			} else {
				this.deleteBookingFailed = true;
			}
		},
		async clickConfirmBookingButton() {
			let bookingChangeToConfirmSuccess = await updateBookingStatusToConfirm(
				this.bookingId
			);

			if (bookingChangeToConfirmSuccess) {
				this.confirmBookingSuccess = true;
				this.$emit("reload");
			} else {
				this.editBookingFailed = true;
			}
		},
		//retrieves the invoice number for the booking being edited
		async getInvoiceNo() {
			this.bookingInvoiceNo = await getInvoiceNumber(this.bookingId);
		},
	},
};
</script>

<template>
	<!-- Edit Event Model Model -->
	<b-modal
		v-model="showModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		no-close-on-esc
		header-close-content
		scrollable
	>
		<div class="row mt-3 justify-content-center">
			<div class="col-md-12 mb-3">
				<h5>{{ $t("booking.editBooking.title") }}</h5>
			</div>
			<!-- Edit Sucees and Failed Msg -->
			<div class="col-md-12 mb-3">
				<b-alert v-model="editBookingFailed" variant="danger" dismissible
					><i class="bx bx-error-circle mr-2"></i
					>{{ $t("booking.editBooking.bookingEditFailed") }}</b-alert
				>
				<b-alert v-model="confirmBookingSuccess" variant="success" dismissible
					><i class="mdi mdi-check-all mr-2"></i
					>{{ $t("booking.editBooking.bookingConfirmationSuccess") }}</b-alert
				>
				<b-alert v-model="deleteBookingSuccess" variant="success" dismissible
					><i class="mdi mdi-check-all mr-2"></i
					>{{ $t("booking.editBooking.bookingDeleteSuccess") }}</b-alert
				>
				<b-alert v-model="deleteBookingFailed" variant="danger" dismissible
					><i class="mdi mdi-check-all mr-2"></i
					>{{ $t("booking.editBooking.bookingEditFailed") }}</b-alert
				>
			</div>
			<!-- booking title -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-notification font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingTitle") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.bookingTitle }} {{ this.subPackage.title }}
			</div>
			<!-- booking Date -->
			<div class="col-md-4 mt-3">
				<label>
					<i class="bx bx-calendar-alt font-size-16 align-middle mr-1"></i>
					{{ $t("booking.editBooking.bookinDate") }}:
				</label>
			</div>
			<div class="col-md-8 mt-3">
				{{ this.startTime.toString().slice(0, 15) }}
			</div>
			<!-- booking Starting Time -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-time font-size-16 align-middle mr-1"></i>
					{{ $t("booking.editBooking.bookingStratingTime") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.startTime.getHours() }}:{{ this.startTime.getMinutes() }}
			</div>
			<!-- booking Ending Time -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-time-five font-size-16 align-middle mr-1"></i>
					{{ $t("booking.editBooking.bookingEndingTime") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.endTime.getHours() }}:{{ this.endTime.getMinutes() }}
			</div>
			<!-- booking Status -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-food-tag font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingStatus") }}:
				</label>
			</div>
			<div class="col-md-8">
				<b-badge
					v-if="this.status === 'PENDING'"
					class="mr-1 font-size-12"
					variant="warning"
				>
					{{ $t("booking.bookingTypes.pending") }}
				</b-badge>
				<b-badge
					v-if="this.status === 'CONFIRMED'"
					class="mr-1 font-size-12"
					variant="success"
				>
					{{ $t("booking.bookingTypes.confirmed") }}
				</b-badge>
				<b-badge
					v-if="this.status === 'REJECTED'"
					class="mr-1 font-size-12"
					variant="danger"
				>
					{{ $t("booking.bookingTypes.rejected") }}
				</b-badge>
				<b-badge
					v-if="this.status === 'CANCELLED'"
					class="mr-1 font-size-12"
					variant="danger"
				>
					{{ $t("booking.bookingTypes.rejected") }}
				</b-badge>
			</div>
			<!-- Booking Payment Method -->
			<div class="col-md-5">
				<label>
					<i class="bx bx-money font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingPaymethod") }}:
				</label>
			</div>
			<div class="col-md-7">
				<div v-if="this.paymentMethod === 'card'">Karte</div>
				<div v-else-if="this.paymentMethod === 'sepa_debit'">SEPA</div>
				<div v-else>Andere</div>
			</div>
			<!-- Booking Payment Id -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-credit-card font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingPaymentId") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.paymentId }}
			</div>
			<div class="col-md-12 border-top mt-3 mb-3"></div>
			<!-- Package Name -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-package font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingPackage") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.subPackage.package.title }}
			</div>
			<!-- Subpackage Name -->
			<div class="col-md-4">
				<label>
					<i class="bx bxs-package font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingSubpackage") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.subPackage.title }}
			</div>
			<!-- Number of Packs -->
			<div class="col-md-5">
				<label>
					<i class="bx bx-group font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bbokingNumberOfPacks") }}:
				</label>
			</div>
			<div class="col-md-7">
				{{ this.numOfPacks }}
			</div>
			<!-- Extras -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-extension font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingExtras") }}:
				</label>
			</div>
			<div class="col-md-8">
				<span v-for="(extra, extraIndex) in this.extras" :key="extraIndex">
					<b-badge class="mr-1 font-size-12" variant="light">
						{{ extra.title }}
					</b-badge>
				</span>
			</div>
			<div class="col-md-12 border-top mt-3 mb-3"></div>
			<!-- booking Name -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-user font-size-16 align-middle mr-1"></i>
					{{ $t("booking.editBooking.bookingReserverName") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.reserverName }}
			</div>
			<!-- booking Email -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-envelope font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingReserverEmail") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.reserverEmail }}
			</div>
			<!-- booking Telephone -->
			<div class="col-md-4">
				<label>
					<i class="bx bx-phone font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingReserverTelephone") }}:
				</label>
			</div>
			<div class="col-md-8">
				{{ this.reserverTelephone }}
			</div>
			<!-- booking Invoice -->
			<div class="col-md-5">
				<label>
					<i class="bx bx-calculator font-size-16 align-middle mr-1"></i
					>{{ $t("booking.editBooking.bookingInvoiceNumber") }}:
				</label>
			</div>
			<div class="col-md-7">
				{{ this.bookingInvoiceNo }}
			</div>
			<div class="col-md-12 border-top mt-3 mb-3"></div>
			<!-- booking Note -->
			<div class="col-md-12">
				<label>
					<i class="bx bx-note font-size-16 align-middle mr-1"></i>
					{{ $t("booking.editBooking.bookingNote") }}:
				</label>
			</div>
			<div class="col-md-12">
				{{ this.bookingNote }}
			</div>
		</div>
		<!-- Action -->
		<div class="row mt-5">
			<div class="col-md-12">
				<b-button
					v-if="this.status === 'PENDING' && this.bookingValid"
					class="mr-2"
					variant="success"
					@click="clickConfirmBookingButton()"
				>
					<i class="bx bxs-check-circle mr-1"></i>
					{{ $t("booking.editBooking.bookingConfirmButton") }}</b-button
				>
				<b-button
					v-if="this.bookingValid"
					class="mr-2"
					variant="danger"
					@click="clickDeleteBookingButton()"
				>
					<i class="bx bxs-trash mr-1"></i>
					{{ $t("general.buttons.delete") }}</b-button
				>
				<b-button
					v-if="this.bookingPassed"
					class="mr-2"
					variant="danger"
					@click="clickDeleteBookingButton()"
				>
					<i class="bx bxs-trash mr-1"></i>
					{{ $t("general.buttons.delete") }}</b-button
				>
				<b-button variant="light" @click="clickCloseButton()">
					<i class="bx bx-x mr-1"></i>
					{{ $t("general.buttons.cancel") }}</b-button
				>
			</div>
		</div>
	</b-modal>
</template>
